import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { SchemasManager } from "../../Managers/SchemasManager";
import { Languages } from "../../Utils/Languages";
import { Bet } from "../../GameComponents/Bet";
import { HtmlTouchContainerElement } from "../../CustomComponents/HtmlTouchContainerElement";
import { RouletteActions } from "../../Channels/Common/Actions/RouletteActions";
import { HtmlButtonElement } from "../Elements/HtmlButtonElement";
import { HtmlSchemaSelectButtonElement } from "../../CustomComponents/HtmlSchemaSelectButtonElement";
import { HtmlController } from "../HtmlController";
import { DataManager } from "../../Managers/DataManager";
import { Scaling } from "../../Utils/Scaling";
import { PlayList } from "../../Components/Sounds/PlayList";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlDefaultSchemeSelectorContainerElement extends HtmlTouchContainerElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private static VisibleCount = 8;

    private static MobileVisibleCount = 1;

    private static LastElementFix = 1;

    private static MobileLastElementFix = 4;

    private schemaDefaultSelectButtons: Array<HtmlButtonElement>;

    private count: number;

    private page: number;

    private maxPage: number;

    private pageWidth: number;

    private pageHeight: number;

    private nextButton: HTMLElement;

    private previousButton: HTMLElement;

    private wrapper: HTMLElement;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor() {
        super();

        this.page = 0;
    }

    //******************************************************************************************************************
    //  CREATE
    //******************************************************************************************************************

    create(node: Element): void {
        super.create(node);

        if (window["CHANNEL"] == "mobile") {
            HtmlDefaultSchemeSelectorContainerElement.VisibleCount =
                HtmlDefaultSchemeSelectorContainerElement.MobileVisibleCount;
            HtmlDefaultSchemeSelectorContainerElement.LastElementFix =
                HtmlDefaultSchemeSelectorContainerElement.MobileLastElementFix;
        }

        SchemasManager.initialize();

        this.createDefaultSchemas();
        this.createControls();
        this.createSwipeControls();
        this.createFakeControls();

        if (Scaling.Emitter != null) {
            Scaling.Emitter.on(Scaling.EventResize, this.updatePage.bind(this, false));
        }

        this.updatePage();
    }

    private createDefaultSchemas(): void {
        this.wrapper = document.getElementById("favoriteDefaultSchemasWrapper");
        this.count = SchemasManager.getDefaultSchemasCount();

        if (this.wrapper) {
            this.schemaDefaultSelectButtons = [];
            for (let i = 0; i < this.count; i++) {
                let button = this.createSchemaButton(
                    i,
                    RouletteActions.ActionSchemasDefaultSelect,
                    Languages.getRid("SCHEMA_" + i),
                );
                this.schemaDefaultSelectButtons.push(button);
            }

            const visible = HtmlDefaultSchemeSelectorContainerElement.VisibleCount;
            this.maxPage = 0;
            while (this.maxPage * visible < this.count) {
                const pageWrapper = document.createElement("div");
                pageWrapper.classList.add("favoriteDefaultSchemasPage");

                for (let i = 0; i < visible; i++) {
                    const index = visible * this.maxPage + i;
                    if (index < this.schemaDefaultSelectButtons.length) {
                        if (window["CHANNEL"] == "mobile") {
                            this.maxPage++;
                        }
                        pageWrapper.appendChild(this.schemaDefaultSelectButtons[index].instance);
                    }
                }
                if (window["CHANNEL"] == "desktop") {
                    this.maxPage++;
                }
                this.wrapper.appendChild(pageWrapper);
            }
        }
    }

    private createSchemaButton(index: number, action: string, text: string): HtmlButtonElement {
        let button = new HtmlSchemaSelectButtonElement(index);
        button.action = action;
        button.registerEvents();
        button.instance.classList.add("schemaBtn");
        button.setText(text);
        HtmlController.registerActionElement(action, button);

        return button;
    }

    private createControls(): void {
        if (this.maxPage == 1) {
            return;
        }

        const holder = document.getElementById("favoriteSchemasControls");
        if (holder != null) {
            this.nextButton = this.createControlButton(holder, "schemaBtnNext", this.nextPage.bind(this));
            this.previousButton = this.createControlButton(holder, "schemaBtnPrevious", this.previousPage.bind(this));
        }
    }

    private createControlButton(holder: HTMLElement, className: string, action: () => void): HTMLElement {
        let button: HTMLElement = document.createElement("div");
        button.classList.add("btn", "schemaControlBtn", className);
        if (className == "schemaBtnPrevious") button.classList.add("_disabled");
        button.onclick = action;
        holder.appendChild(button);
        return button;
    }

    private createSwipeControls(): void {
        if (window["CHANNEL"] == "mobile") {
            //this.on(HtmlTouchContainerElement.evMoveLeft, this.swipeNextPage.bind(this, true));
            this.on(HtmlTouchContainerElement.evMoveUp, this.swipeNextPage.bind(this));

            //this.on(HtmlTouchContainerElement.evMoveRight, this.swipePreviousPage.bind(this, true));
            this.on(HtmlTouchContainerElement.evMoveDown, this.swipePreviousPage.bind(this));
        }
    }

    private createFakeControls(): void {
        const holder = document.getElementById("favoriteSchemasFakeControls");

        if (holder != null) {
            const button = this.createSchemaButton(-1, RouletteActions.ActionSchemasDefaultSelect, "");
            holder.appendChild(button.instance);
        }
    }

    //******************************************************************************************************************
    //  PUBLIC HANDLERS
    //******************************************************************************************************************

    public selectDefaultScheme(bets: Array<Bet>): Array<Bet> {
        let currentBets = SchemasManager.getDefaultSchemaByIndex(DataManager.SchemaSelected);
        let button = this.schemaDefaultSelectButtons[DataManager.SchemaSelected];
        this.resetSchemas();

        if (button != null) {
            button.instance.classList.add("_active");
        }
        return currentBets;
    }

    public resetSchemas(resetPage: boolean = false): void {
        let schemaBtns = document.querySelectorAll(".schemaBtn");
        for (let i = 0; i < schemaBtns.length; i++) {
            const button = schemaBtns[i];
            button.classList.remove("_active");
        }

        if (resetPage) {
            this.page = 0;
        }

        this.updateControls();
        this.updatePage();
    }

    public showPagination(visible: boolean): void {
        if (this.nextButton != null && this.previousButton != null) {
            if (visible) {
                this.nextButton.classList.remove("_hidden");
                this.previousButton.classList.remove("_hidden");
            } else {
                this.nextButton.classList.add("_hidden");
                this.previousButton.classList.add("_hidden");
            }
        }
    }

    //******************************************************************************************************************
    //  PRIVATE HANDLERS
    //******************************************************************************************************************

    private swipeNextPage(inPortrait: boolean): void {
        PlayList.play("SND_Click");
        this.nextPage();
    }

    private swipePreviousPage(inPortrait: boolean): void {
        PlayList.play("SND_Click");
        this.previousPage();
    }

    private nextPage(): void {
        if (this.page == this.maxPage - HtmlDefaultSchemeSelectorContainerElement.LastElementFix) {
            return;
        }

        this.page++;
        this.updatePage(true);
        this.updateControls();
    }

    private previousPage(): void {
        if (this.page == 0) {
            return;
        }

        this.page--;
        this.updatePage(true);
        this.updateControls();
    }

    private updateControls(): void {
        if (this.nextButton == null || this.previousButton == null) {
            return;
        }

        this.nextButton.classList.remove("_disabled");
        this.previousButton.classList.remove("_disabled");

        if (this.page == this.maxPage - HtmlDefaultSchemeSelectorContainerElement.LastElementFix) {
            this.nextButton.classList.add("_disabled");
        }

        if (this.page == 0) {
            this.previousButton.classList.add("_disabled");
        }
    }

    private updatePage(animate: boolean = false): void {
        this.pageHeight =
            parseInt(window.getComputedStyle(this.instance).height) / (window["CHANNEL"] == "mobile" ? 4 : 1);

        this.wrapper.style.transition = `transform ${animate ? 200 : 0}ms`;
        this.wrapper.offsetWidth;

        this.wrapper.style.transform = `translate3d(0px,${this.page * this.pageHeight * -1}px,0)`;
        this.wrapper.style.width = "";
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Custom/HtmlDefaultSchemeSelectorContainerElement.ts
 **/